import React, {useEffect} from "react";
import {CustomStyleExpandImage, CustomStyleOverlayExpandImage} from "./Styles";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description CustomImageTable
 * @param UseState expandImage: Path from image (required)
 * @param UseState setExpandImage: Use State from expandImage (required)
 * @returns {JSX.Element}
 */
const CustomExpandImage = ({expandImage, setExpandImage}) =>{

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                cleanExpandImage();
            }
        };
        window.addEventListener('keydown', handleEsc);

        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, []);

    const cleanExpandImage = () => {
        setExpandImage('');
    }

    return (
        <>
            <div onClick={() => {cleanExpandImage()}} className={"overlay " + (expandImage ? '' : 'd-none')} style={CustomStyleOverlayExpandImage}/>
            <img onClick={() => {cleanExpandImage()}} className={(expandImage ? '' : 'd-none')} style={CustomStyleExpandImage} src={expandImage} alt={""}/>
        </>
    );
};
export default CustomExpandImage;
